package org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/kids/ride_to_read/class_2/tucket_bucket")
@Composable
fun TucketBucketPage() {
    BlogLayout(
        PageProperties(
            "Tucket the Bucket",
            ""
        ),
        BlogProperties("Ride To Reader", "Tucket the Bucket (Kuzhali Manickavel)")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Let Us Read",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tucket was the saddest (સૌથી દુઃખી) bucket (ડોલ) in the world. He had once been a garden favourite. The gardener used to swing him by his strong handle as he went to fetch water: \"What a good bucket,\" he said. But as time passed, Tucket the bucket got a hole. Suddenly he was useless.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "What good is a bucket with a hole? Tucket was tossed into the corner of the garden. He was left out in the rain and the sun, and he began to ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "rust.",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sometimes he even got kicked around..\"I should throw that bucket away,\" the gardener ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "muttered.",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tucket didn't want to be thrown away. He felt very sad, though his good friends in the garden tried to cheer him up.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The squirrels set him back up when he was kicked down, and the birds ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "cheerfully flapped",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = " about him.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "\"Don't worry Tucket,\" they chirped ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "soothingly.",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = " Tucket really tried to be happy but it was very, very hard.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "One day, a little girl ran through the garden and stopped in front of Tucket. He sighed and waited for the usual kicks when suddenly he heard \"Perfect!\"",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Soon he found himself ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "blinking ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = "and ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "spluttering ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = "under the garden hose. The girl was cleaning him! He felt heavy ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "chunks ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = "of rust fall off and his spirits brightened.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "\"Oh! You already have a big hole in the bottom!\" said the girl, as she ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "peered ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = "inside. \"Even better!\"",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tucket could not believe what he had just heard. She wanted a bucket with a hole?",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The girl took him to the ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "verandah, ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = "filled him with rich soil and planted a tiny rose inside.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "\"This is a baby rose,\" she said to Tucket. \"You must help me take care of her, okay?\" Tucket was so happy. The girl really wanted him! She even asked him to take care of this small rose. Tucket nearly burst with joy.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He straightened himself up proudly as the girl finished planting. She carefully placed Tucket in the best spot of the verandah. It was a cosy corner, protected from the wind and the rain. Tucket winked and smiled at his friends in the garden. \"Look, I'm taking care of this little rose!\" \"We're very happy for you Tucket,\" chattered the squirrels, and the birds ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "chirped ",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                            .color(Colors.Red)
                    )

                    SpanText(
                        text = "happily.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tucket took great care of the rose and was visited by the girl and his friends every day. He was now the happiest bucket in the world.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Meaning",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Rust: Metal damaged by water or air. The flaky, reddish-brown stuff that forms on iron and steel when they get wet and are exposed to air",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Muttered: Grumbled quietly to oneself",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cheerfully: Happily",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flapped: Moved wings from side to side",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Soothingly (શાંતિદાયક રીતે): In a way that calms someone (કોઈને શાંત પાડે તેવી રીતે)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Blinking: Opening and shutting eyes quickly in surprise",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Peered: Looked carefully. To look closely or carefully especially because something or someone is difficult to see.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Spluttering: Making spitting sounds in surprise (આશ્ચર્યમાં થૂંકવાનો અવાજ કરવો)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Verandah: A raised open space attached to a house. a long, open structure on the outside of a building that has a roof.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Chunks: Thick pieces",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Winked: Closed and opened one eye",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Chirped: Made sounds in a high voice",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Chattered: Made short noises",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tossed – to throw (something) with a quick, light motion.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "New words",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Neglected (અવગણાયેલું)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Favourite",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Fetch",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Corner",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Squirrels",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Usual",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Spirit",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cosy (આરામદાયક)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Saddest",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Happiest",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bucket",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Gardener",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Gardener",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flapped (ફફડાવ્યું)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Make sentences",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )


            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Fetch - The gardener used Tucket to fetch water.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hole - Tucket had a big hole at the bottom.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Winked - Tucket winked at his friends.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Rust - The bucket began to rust.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Correct choose",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The gardener used Tucket to ________________ (fetch water, collect leaves)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When Tucket got a hole, he was tossed into the corner ________________ (of the garden, of the house)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tucket had a big hole ________________ (at the side, at the bottom)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The girl filled Tucket with ________________ (rich soil, small seeds)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Choose the correct word to fill in the blanks.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The gardener used to swing Tucket by his ________________ (strong handle, weak base)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When Tucket got a hole, suddenly he was ________________ to the gardener (useless, useful)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The ________________ set him back up when he was kicked down. (squirrels, birds)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tucket couldn't believe the girl wanted a bucket ________________ (without a handle, with a hole)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tucket nearly burst with ________________ when the girl asked him to take of a rose. (joy, anger)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Metal object used to transport water, soil or objects. Squirrel ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Person who takes care of gardens. Rose",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Animal that keeps food in his/her cheeks. Friendship",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Beautiful flower that smells good. Water",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Relationship that keeps together people that is not family. Bucket",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Element that every person, animal and vegetal need for living. Gardener",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Complete the sentences with word/words from the story.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )


            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tucket, the bucket, got a ________________. hole",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When Tucket was left out in the rain and the sun, he began to ________________. rust",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tucket's friends, the squirrels and the birds, tried to ________________ him up. cheer",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The little girl cleaned Tucket with a ________________. garden hose",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tucket took care of a baby ________________. rose",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Complete the following sentences.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tucket was the saddest ________________. bucket in the world",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tucket was tossed into the corner ________________. corner of the garden",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The squirrels set him ________________. back up",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The girl took him to the ________________. verandah",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "You already have a big hole ________________. in the bottom",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = " ________________ and ________________ were the Tucket’s friends in the garden. Squirrels, birds",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The little girl planted a ________________ in tucket. Baby rose",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Name of tools",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Rake",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Garden hose",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Spade",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Watering can",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Wheel barrow",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Choose the right answer",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Tucket was sad because",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "He was the gardener’s favourite bucket.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "He was shiny and new.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "The gardener did not want him anymore.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em).color(Colors.Green)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Tucket blinked and spluttered because",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "He was sad.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "Water from the hose fell on him.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em).color(Colors.Green)
                        )

                        SpanText(
                            text = "He had a hole in him.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "The girl put Tucket in a cozy spot on the verandah because - ",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "She wanted to protect the rose from too much wind and rain.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em).color(Colors.Green)
                        )

                        SpanText(
                            text = "She wanted the rose to be in the wind and the rain.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "Tucket was too dirty to be taken into the house.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }
            }

            SpanText(
                text = "Read the lines and answer the questions",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "List the action words in these lines - I should throw that bucket away. The gardener muttered as he tripped over Tucket.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The action words are - throw, muttered and tripped.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did the gardener want with Tucket?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The gardener wanted to throw away Tucket.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why was Tucket, the bucket sad?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tucket, the bucket was sad because the was tossed into the corner of the garden.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why was Tucket, the bucket, sad?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tucket was sad because he felt neglected and unused. He was left alone and not given any purpose or attention.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why did the gardener want to throw Tucket away?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The gardener wanted to throw Tucket away because he had a hole.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Once who favoured the bucket?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Once the gardener favoured the bucket.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why was Tucket useless?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "As Tucket grew a hole inside it, it was useless.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How did the gardener hold Tucket?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The gardener swing Tucket by his strong handle.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did the gardener toss Tucket?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The gardener tossed away Tucket into the corner of the garden.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why was the bucket placed in a cozy corner of the verandah?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = " The bucket was placed in a cozy corner of the verandah because this place could protect the tiny rose plant from the wind and the rain.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who picked the bucket up?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "A little girl picked the bucket up.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who were Tucket’s friends?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The squirrels and birds were Tucket’s friends.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where was Tucket left out?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The Tucket was left out in the rain and the sun.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did the girl find Tucket?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The girl found Tucket in the garden.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did she do before she took Tucket to the verandah?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The girl cleaned Tucket before she took him to the verandah.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did the bucket find himself?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The bucket found himself under a garden hose.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did the little girl did after washing the Tucket?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The little girl filled rich soil in Tucket and planted a baby rose in it.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did the girl put the bucket?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The girl put the bucket on the verandah.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Where did the girl place Tucket?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The girl placed Tucket in the best spot of the verandah.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did she do after she put Tucket in the verandah?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "She filled Tucket with dark brown soil and planted a rose inside.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How did the girl use the bucket?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "At first the girl filled the bucket with dark brown soil and then planted a tiny rose inside. In this way she used the bucket.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Describe Tucket when he was a new bucket.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tucket was gardener’s favourite bucket when it was a new bucket as he was strong and shiny.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Write two sound words from the story.",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Two sound words are - chattered (the chattering of the squirrels) and chirped (the chirping of the birds).",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did Tucket do to show his friends that he was happy?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tucket winked and smiled at his friends to show them that he was happy. (Tucket winked and smiled to show his friends that he was happy)",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who were Tucket's friends in the garden?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tucket's friends in the garden were the birds and the plants around him.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What Tucket did when he was happy?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tucket winked and smiled at his friends in the garden.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why do you think Tucket is happy at the end of the story?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tucket is happy at the end of the story because he is put to use again.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )

                        SpanText(
                            text = "I think Tucket is happy at the end of the story because he is now of use. He had been left as a trash. It was lying in one corner of the garden. He is not useless anymore. He is not lying on the corner of the garden. He is put on the veranda by the little girl. He is helping the little girl taking care of the baby rose. The girl has planted the baby rose inside Tucket.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How did the birds try to cheer Tucket up?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The birds cheerfully flapped their wings to cheer Tucket up. (The birds tried to cheer Tucket up by singing and chirping happily near him.)",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How did the birds cheer Tucket?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "The birds cheerfully flapped about him.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why did Tucket straighten himself while the girl finished planting?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tucket straightened himself because he wanted to look his best and be ready to help once the girl finished planting.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who takes care of the rose plant?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Tucket takes care of the rose plant.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "The garden tossed Tucket into the corner of the garden. Can you think of another word for tossed?",
                            modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Thrown away, threw, hurled, flung or chucked.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }
            }
        }
    }
}

//https://vastralpisstd2.blogspot.com/2026/01/subject-english-ch-10-tucket-bucket.html
//https://www.youtube.com/@GeethanjaliKids/videos (Story Jack & Jill)
//https://www.youtube.com/watch?v=ReW4A1h-7Wc
//https://filmot.com/sidebyside/qJ0YBbSP49Q/en/en/English/English/%E0%A4%9F%E0%A4%95%E0%A5%87%E0%A4%9F+%E0%A4%A8%E0%A4%BE%E0%A4%AE+%E0%A4%95%E0%A5%80+%E0%A4%AC%E0%A4%BE%E0%A4%B2%E0%A5%8D%E0%A4%9F%E0%A5%80+Learn+Hindi+with+subtitles+-+Story+for+Children+%22BookBox.Com%22/BookBox+Hindi